<template>
  <div class="index" style="width: 100%;">
    <img style="height: 100%;width: 100%;" :src="src" />
    <div class="fixed">
      <van-button style="width: 40%;" block type="default">转发</van-button>
      <van-button style="width: 43%;" block type="info" color="#294ba3">分享到朋友圈</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: ''
    }
  },
  watch: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
  },
  created() {
    if(this.$route.query.url){
      this.src = this.$route.query.url
    }
  }
}
</script>

<style lang="less" scoped>
.fixed{
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #f6f7fa;
  padding: 12px 10px;
  display: flex;
  align-items: center;
  // justify-content: space-around;
  justify-content: space-between;
  max-width:500px;
}
.index {
  font-size: 14px;
  height: 100%;
  background: #fff;

  p {
    margin: 0 !important;
  }

  .fs17 {
    font-size: 17px;
  }

  .fs14 {
    font-size: .14px;
  }

  .title-serch{
    display: flex;
    align-items: center;
    justify-content: space-between;

  }

  .bet{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content {
    background: #f2f4f8;
    height: 92%;
    margin-top: -15px;

  }
}
</style>
